import { Component, Injector, inject as inject_1 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule, JkBaseOption, JkDialogEditComponent, jkRestReturn } from 'jk-service';
import { StkmfService, templateUrlConfigStk } from './../_service_stk';
import { Stkmf } from '../_entity_stk';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule } from 'jk-advcom';


@Component({
  selector: 'app-stkmf-edit',
  templateUrl: './stkmf-editPkg.component.html',//templateUrlConfigStk.stkmf,
  styleUrls: [],
  standalone: true,
  imports: [JackBaseComponentModule, MaterialModule, AdvComModule],
})

export class StkmfEditComponent extends JkDialogEditComponent<StkmfService, Stkmf> {
  override dialogRef: MatDialogRef<StkmfEditComponent>;
  override data: jkRestReturn;

  override srv!: StkmfService;
  constructor() {
    const inject = inject_1(Injector);
    const dialogRef = inject_1<MatDialogRef<StkmfEditComponent>>(MatDialogRef);
    const data = inject_1<jkRestReturn>(MAT_DIALOG_DATA);

    super(inject, dialogRef, data);
  
    this.dialogRef = dialogRef;
    this.data = data;
  }


}
